export const NOTIFICATION_LAYERS = [
  { value: 'all', label: 'همه' },
  { value: 'security', label: 'امنیتی' },
  { value: 'finance', label: 'مالی' },
  { value: 'technical', label: 'فنی' },
  { value: 'operational', label: 'عملیاتی' },
];

export const NOTIFICATION_SEVERITIES = [
  { value: 'all', label: 'هر شدتی' },
  { value: 'info', label: 'اطلاع' },
  { value: 'warning', label: 'هشدار' },
  { value: 'critical', label: 'بحرانی' },
];

export function notificationLayerLabel(layer) {
  return NOTIFICATION_LAYERS.find((item) => item.value === layer)?.label || 'عملیاتی';
}

export function notificationSeverityLabel(severity) {
  return NOTIFICATION_SEVERITIES.find((item) => item.value === severity)?.label || 'اطلاع';
}

export function notificationSeverityColor(severity) {
  if (severity === 'critical') return 'red';
  if (severity === 'warning') return 'orange';
  return 'blue';
}

export function notificationLayerColor(layer) {
  if (layer === 'security') return 'red';
  if (layer === 'finance') return 'gold';
  if (layer === 'technical') return 'purple';
  return 'cyan';
}
